import { render } from "./PracticeTestModal.vue?vue&type=template&id=f28ec476&scoped=true"
import script from "./PracticeTestModal.vue?vue&type=script&lang=js"
export * from "./PracticeTestModal.vue?vue&type=script&lang=js"

import "./PracticeTestModal.vue?vue&type=style&index=0&id=f28ec476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28ec476"]])

export default __exports__